import { FC } from 'react'
import { FormattedDate } from 'react-intl'

export const FormattedTimestamp: FC<{ value: Date | null | undefined }> = ({
	value,
}) =>
	value && <FormattedDate value={value} dateStyle="short" timeStyle="medium" />
